import { createFileRoute } from "@tanstack/react-router";
import { PortalShell } from "@/components/portal/PortalShell";
import { RoleDashboard } from "@/components/portal/RoleDashboard";

const NAV = [
  { to: "/app/management", label: "Dashboard" },
  { to: "/app/approvals", label: "Freigaben" },
  { to: "/app/crm/projects", label: "Projekte" },
  { to: "/app/admin", label: "Admin" },
];

export const Route = createFileRoute("/_authenticated/app/management")({
  ssr: false,
  head: () => ({ meta: [{ title: "Managementportal" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => (
    <PortalShell nav={NAV}>
      <RoleDashboard title="Managementportal" scope="management" />
    </PortalShell>
  ),
});
